<aside class="sidebar-container">
  <header class="sidebar-container-header">
    <h3 class="sidebar-container-header-title">
      {{ (user$ | async)?.firstName | titlecase }}
      {{ (user$ | async)?.lastName | uppercase }}
    </h3>
  </header>

  <section class="sidebar-container-content">
    <ul class="sidebar-container-content-list">
      <mat-divider></mat-divider>
      <li class="sidebar-container-content-list-item">
        <button type="button" mat-flat-button (click)="navigateTo(['/'])">
          <mat-icon>home</mat-icon>
          <span i18n="component sidebar général | bouton">dashboard</span>
        </button>
      </li>
      <li class="sidebar-container-content-list-item">
        <button
          type="button"
          mat-flat-button
          (click)="navigateTo(['analyses'])"
        >
          <mat-icon>troubleshoot</mat-icon>
          <span i18n="component sidebar général | bouton">analysis</span>
        </button>
      </li>
      <li class="sidebar-container-content-list-item">
        <button type="button" mat-flat-button (click)="navigateTo(['bots'])">
          <mat-icon>rocket_launch</mat-icon>
          <span i18n="component sidebar général | bouton">
            robot d'execution
          </span>
        </button>
      </li>
      <li class="sidebar-container-content-list-item">
        <button
          type="button"
          mat-flat-button
          (click)="navigateTo(['campaigns'])"
        >
          <mat-icon>account_tree</mat-icon>
          <span i18n="component sidebar général | bouton">campagnes</span>
        </button>
      </li>
      <li class="sidebar-container-content-list-item">
        <button
          type="button"
          mat-flat-button
          (click)="navigateTo(['scheduler'])"
        >
          <mat-icon>alarm</mat-icon>
          <span i18n="component sidebar général | bouton">planification</span>
        </button>
      </li>
      <li class="sidebar-container-content-list-item">
        <button
          type="button"
          mat-flat-button
          (click)="navigateTo(['incidents'])"
        >
          <mat-icon>report_problem</mat-icon>
          <span i18n="component sidebar général | bouton">incident</span>
        </button>
      </li>
      <li class="sidebar-container-content-list-item" *appHasRole="['Admin']">
        <button type="button" mat-flat-button (click)="navigateTo(['company'])">
          <mat-icon>store</mat-icon>
          <span i18n="component sidebar général | bouton">Company</span>
        </button>
      </li>
      <mat-divider></mat-divider>
      <li
        class="sidebar-container-content-list-item"
        *appHasRole="['Admin', 'Operator']"
      >
        <button
          type="button"
          mat-flat-button
          (click)="navigateTo(['variables'])"
        >
          <mat-icon>data_object</mat-icon>
          <span i18n="component sidebar général | bouton">variables</span>
        </button>
      </li>
      <li class="sidebar-container-content-list-item">
        <button
          type="button"
          mat-flat-button
          (click)="navigateTo(['settings'])"
        >
          <mat-icon>settings</mat-icon>
          <span i18n="component sidebar général | bouton">réglages</span>
        </button>
      </li>
      <li class="sidebar-container-content-list-item">
        <button type="button" mat-flat-button (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span i18n="component sidebar général | bouton">déconnexion</span>
        </button>
      </li>
    </ul>
  </section>
</aside>
